import React from 'react';

export const CheckPrimaryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.7517 3.92335L5.47948 11.1933C5.34726 11.3255 5.21504 11.3916 5.0167 11.3916C4.81837 11.3916 4.68615 11.3255 4.55393 11.1933L1.24838 7.88879C0.983938 7.62443 0.983938 7.22789 1.24838 6.96352C1.51283 6.69916 1.90949 6.69916 2.17393 6.96352L5.0167 9.80543L11.8261 2.99808C12.0906 2.73371 12.4872 2.73371 12.7517 2.99808C13.0161 3.26244 13.0161 3.65898 12.7517 3.92335Z"
        fill="#774EFF"
      />
    </svg>
  );
};
